import { gql } from "@apollo/client";

export const BUILDING_PHOTOS_FIELDS_FRAGMENT = gql`
  fragment BuildingPhotosFieldsV2 on BuildingInterface {
    id
    slug
    name
    images {
      id
      name
      caption
      location
      url
      thumbnailUrl
      lightboxUrl
      accessibilityFeatures
    }
    __typename
  }
`;

export default BUILDING_PHOTOS_FIELDS_FRAGMENT;
